// extracted by mini-css-extract-plugin
export default {"component":"tG+vR"};